
export default {
  component:   "pe-spinner",

  // elements
  animation:   "pe-spinner__animation",
  placeholder: "pe-spinner__placeholder",

  // states
  animated:    "pe-spinner--animated",
  fab:         "pe-spinner--fab",
  large:       "pe-spinner--large",
  medium:      "pe-spinner--medium",
  permanent:   "pe-spinner--permanent",
  raised:      "pe-spinner--raised",
  regular:     "pe-spinner--regular",
  singleColor: "pe-spinner--single-color",
  small:       "pe-spinner--small",
  visible:     "pe-spinner--visible",
};
